import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row, Input } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import PageTitle from '../../../components/PageTitle';
import {
    delete_News,
    list_Internship,
    list_News,
    list_Publication,
    update_News,
} from '../../../helpers/actions/api.functions';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as FeatherIcon from 'react-feather';
import parse from 'html-react-parser';

import FilterButton from '../../../components/FilterButton';

const PublicationDetails = () => {
    const history = useHistory();
    let userdata = localStorage.getItem('active_user') ? JSON.parse(localStorage.getItem('active_user')) : null;
    const param = useParams();
    const [data, setData] = useState({});
    const [isActive, setIsActive] = useState(true);
    const [modalb, setModalb] = useState(false);
    // const [view, setView] = useState(false);

    // const toggleb = () => setModalb(!modalb);

    const getPublications = () => {
        setIsActive(true);
        list_Publication()
            .then((res) => {
                setIsActive(false);
                setData(res.data.filter((sc) => sc.id == param.id)[0]);
                console.log(res);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.message);
            });
    };
    useEffect(() => {
        getPublications();
    }, [param.id]);

    if (isActive) {
        return <PreloaderWidget />;
    }

    const openFile = (file) => {
        if (file) {
            window.open(file, '_blank');
        }
    };

    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Publications And Newsletters', path: '/publications-list' },
                            { label: 'Details', path: '/publication-detail', active: true },
                        ]}
                        title="Publication Details"
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6} xl={12} className="mx-auto">
                    <Card>
                        <CardBody className="pb-0">
                            <div className="mt-3 pt-2 ">
                                {/* <h4 className="mb-3 font-size-15">Detailed  Information</h4> */}
                                <div className="table-responsive incu-detail">
                                    <table className="table  table-striped  text-muted">
                                        <tbody className="">
                                            <tr>
                                                <th scope="row">Title</th>
                                                <td className="text-capitalize">{data?.title}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Link</th>
                                                <td className="">{data?.link}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Description</th>
                                                <td className="">
                                                    {data?.description && parse(data?.description)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Image</th>
                                                <td>
                                                    <Button
                                                        size="sm"
                                                        color={'warning'}
                                                        onClick={(e) => {
                                                            openFile(data?.image);
                                                        }}>
                                                        Download
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <br />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default PublicationDetails;
